import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@nucleus-commerce/ui/components/alert';

export interface PublishConflictAlertProps {
  productId: string;
  /** Status of the master product the backend refused to publish. */
  productStatus: string;
  requestId?: string | undefined;
}

/** 409 on publish: only an active master product can go live; links to where that is fixed. */
export function PublishConflictAlert({
  productId,
  productStatus,
  requestId,
}: PublishConflictAlertProps) {
  const { t } = useTranslation(['storeCatalog', 'errors']);
  return (
    <Alert variant="destructive" role="alert">
      <AlertTitle>{t('storeCatalog:publishConflict.title')}</AlertTitle>
      <AlertDescription>
        <p>
          {t('storeCatalog:publishConflict.description', {
            status: t(`storeCatalog:masterStatus.${productStatus}`, {
              defaultValue: productStatus,
            }),
          })}
        </p>
        <Link
          to="/org/products/$productId"
          params={{ productId }}
          className="font-medium underline underline-offset-4"
        >
          {t('storeCatalog:publishConflict.openMaster')}
        </Link>
        {requestId ? (
          <span className="block text-xs">{t('errors:requestIdShort', { requestId })}</span>
        ) : null}
      </AlertDescription>
    </Alert>
  );
}
